import { ActiveUsers } from '../Admin/ActiveUsers';
import AddUser from '../Admin/AddUser';
import { AdminProtectedRoute } from './AdminProtectedRoute';
import { DeletedItems } from '../Admin/DeletedItems';
import { DeviceRefreshReportPage } from '../Admin/DeviceRefreshReport';
import { EditOwnerPage } from '../Admin/EditOwner/index';
import EditUser from '../Admin/EditUser';
import ImportVerification from '../ImportVerification';
import { OwnersPage } from '../Admin/Owners/index';
import React from 'react';
import Settings from '../Admin/Settings';
import { Switch } from 'react-router-dom';
import { UnassignedAssets } from '../Admin/UnassignedAssets';
import { ViewUsers } from '../Admin/ViewUsers';
import { PerDeptDeviceList } from '../Admin/DeviceRefreshReport/PerDeptDeviceList';
import { DeviceArchiveReportPage } from '../Admin/DeviceRefreshReport/DeviceArchiveReportPage';
import { PerFYDeviceRefreshReport } from '../Admin/DeviceRefreshReport/PerFYRefreshReport';

export const AdminSwitch = (props: any) => {
  return (
    <Switch>
      <AdminProtectedRoute exact path='/Admin/addUser' component={AddUser} />
      <AdminProtectedRoute exact path='/Admin/viewUsers' component={ViewUsers} />
      <AdminProtectedRoute exact path='/Admin/editUser/:id' component={EditUser} />
      <AdminProtectedRoute exact path='/Admin/deletedItems' component={DeletedItems} />
      <AdminProtectedRoute exact path='/Admin/activeUsers' component={ActiveUsers} />
      <AdminProtectedRoute exact path='/Admin/unassignedAssets' component={UnassignedAssets} />
      <AdminProtectedRoute exact path='/Admin/settings' component={Settings} />
      <AdminProtectedRoute exact path='/ImportVerification/' component={ImportVerification} />
      <AdminProtectedRoute exact path='/Admin/owners/:updated?' component={OwnersPage} />
      {/* <AdminProtectedRoute exact path='/Admin/editOwner/:ownerNumber' component={EditOwnerPage} /> */}
      <AdminProtectedRoute exact path='/Admin/deviceRefreshReport' component={DeviceRefreshReportPage} />
      <AdminProtectedRoute exact path='/Admin/deviceRefreshReport/:deptId/:sixYears' component={PerDeptDeviceList} />
      <AdminProtectedRoute exact path='/Admin/deviceArchiveReport'  component={DeviceArchiveReportPage}/>
      <AdminProtectedRoute exact path='/Admin/perFYDeviceReport' component={PerFYDeviceRefreshReport}/>
    </Switch>
  );
};
